import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import Marketplace from "@/components/site/Marketplace";

export default function UsedGoodsPage() {
  return (
    <div className="min-h-screen bg-[#FAF8F5]" data-testid="used-goods-page">
      <Header />
      <main className="pt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-6">
          <Link to="/" data-testid="used-goods-back-home" className="inline-flex items-center gap-1 text-sm font-bold text-[#0C2E2B] hover:underline">
            <ArrowLeft className="w-4 h-4" /> Back home
          </Link>
        </div>
        <Marketplace />
      </main>
      <Footer />
    </div>
  );
}
